import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const TaxRatesTaxRates = lazy(() => import('./taxRates/TaxRates'));

const TaxRatesAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/settings/vat',
			element: <TaxRatesTaxRates />
		}
	]
};

export default TaxRatesAppConfig;
